import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CallIcon from "@material-ui/icons/CallReceived";
import WebhookIcon from "@material-ui/icons/CodeOutlined";
import ScheduleIcon from "@material-ui/icons/ScheduleOutlined";
import BoltIcon from "@material-ui/icons/FlashOnOutlined";
import ApiCallIcon from "@material-ui/icons/PhoneInTalkOutlined";

import { i18n } from "../../translate/i18n";
import { triggerList } from "./triggers";

const ICONS = {
  inbound_call: CallIcon,
  webhook: WebhookIcon,
  scheduled: ScheduleIcon,
  api_call: ApiCallIcon,
};

const useStyles = makeStyles(theme => ({
  search: { marginBottom: theme.spacing(1.5) },
  card: {
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    width: "100%",
    textAlign: "left",
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1.5),
    borderRadius: 12,
    border: `1px solid ${theme.app.border}`,
    background: "#fff",
    cursor: "pointer",
    "&:hover": { borderColor: theme.app.lime, background: theme.app.selectedRow },
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    flexShrink: 0,
  },
  title: { fontWeight: 700 },
  desc: { fontSize: 13, color: theme.app.textSecondary },
  empty: { color: theme.app.textTertiary, padding: theme.spacing(2, 0) },
}));

const norm = s => (s || "").toLowerCase();

const TriggerModal = ({ open, onClose, onPick }) => {
  const classes = useStyles();
  const [q, setQ] = useState("");
  const query = norm(q.trim());

  const list = triggerList().filter(
    t => !query || norm(t.title).includes(query) || norm(t.desc).includes(query)
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("triggers.choose")}</DialogTitle>
      <DialogContent>
        <TextField
          className={classes.search}
          fullWidth
          size="small"
          variant="outlined"
          autoFocus
          placeholder="Buscar gatilho…"
          value={q}
          onChange={e => setQ(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        {list.length === 0 ? (
          <Typography className={classes.empty}>Nenhum gatilho encontrado.</Typography>
        ) : (
          list.map(t => {
            const Icon = ICONS[t.key] || BoltIcon;
            return (
              <div key={t.key} className={classes.card} role="button" onClick={() => onPick(t.key)}>
                <div className={classes.icon} style={{ background: t.color }}>
                  <Icon />
                </div>
                <div>
                  <Typography className={classes.title}>{t.title}</Typography>
                  <Typography className={classes.desc}>{t.desc}</Typography>
                </div>
              </div>
            );
          })
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{i18n.t("apps.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TriggerModal;
